import { clearAllSessionCaches } from '@/utils/teamsSessionCache';

export const getZoomBotStorageKey  = (meetingId: string) => `${meetingId}_botId`;
export const getWebexBotStorageKey = (meetingId: string) => `${meetingId}_botId`;
export const getMeetBotStorageKey  = (meetingId: string) => `${meetingId}_botId`;
export const getTeamsBotStorageKey = (meetingId: string) => `${meetingId}__botId`;

export function clearBotIdEntriesFromLocalStorage() {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key?.endsWith('_botId')) {
      localStorage.removeItem(key);
    }
  }

  clearAllSessionCaches();
}
